export default [
    {
        "id": 1,
        "name": "PC",
        "slug": "pc",
        "platforms": [
            {
                "id": 4,
                "name": "PC",
                "slug": "pc",
                "games_count": 541960,
                "image_background": "https://media.rawg.io/media/games/b7d/b7d3f1715fa8381a4e780173a197a615.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 2,
        "name": "PlayStation",
        "slug": "playstation",
        "platforms": [
            {
                "id": 187,
                "name": "PlayStation 5",
                "slug": "playstation5",
                "games_count": 1179,
                "image_background": "https://media.rawg.io/media/games/253/2534a46f3da7fa7c315f1387515ca393.jpg",
                "image": null,
                "year_start": 2020,
                "year_end": null
            },
            {
                "id": 18,
                "name": "PlayStation 4",
                "slug": "playstation4",
                "games_count": 6877,
                "image_background": "https://media.rawg.io/media/games/be0/be01c3d7d8795a45615da139322ca080.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 16,
                "name": "PlayStation 3",
                "slug": "playstation3",
                "games_count": 3167,
                "image_background": "https://media.rawg.io/media/games/c6b/c6bfece1daf8d06bc0a60632ac78e5bf.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 15,
                "name": "PlayStation 2",
                "slug": "playstation2",
                "games_count": 2052,
                "image_background": "https://media.rawg.io/media/games/e60/e601c02ec49ef4f1d5ef147994b3935f.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 27,
                "name": "PlayStation",
                "slug": "playstation1",
                "games_count": 1678,
                "image_background": "https://media.rawg.io/media/games/45d/45da4dc311d84b79230317d7b24a3dec.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 19,
                "name": "PS Vita",
                "slug": "ps-vita",
                "games_count": 1449,
                "image_background": "https://media.rawg.io/media/games/f3e/f3eec35c6218dcfd93a537751e6bfa61.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 17,
                "name": "PSP",
                "slug": "psp",
                "games_count": 1373,
                "image_background": "https://media.rawg.io/media/games/dd7/dd72d8a527cd9245c7eb7cd05aa53efa.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 3,
        "name": "Xbox",
        "slug": "xbox",
        "platforms": [
            {
                "id": 1,
                "name": "Xbox One",
                "slug": "xbox-one",
                "games_count": 5672,
                "image_background": "https://media.rawg.io/media/games/d1a/d1a2e99ade53494c6330a0ed945fe823.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 186,
                "name": "Xbox Series S/X",
                "slug": "xbox-series-x",
                "games_count": 1030,
                "image_background": "https://media.rawg.io/media/games/5eb/5eb49eb2fa0738fdb5bacea557b1bc57.jpg",
                "image": null,
                "year_start": 2020,
                "year_end": null
            },
            {
                "id": 14,
                "name": "Xbox 360",
                "slug": "xbox360",
                "games_count": 2805,
                "image_background": "https://media.rawg.io/media/games/7fa/7fa0b586293c5861ee32490e953a4996.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 80,
                "name": "Xbox",
                "slug": "xbox-old",
                "games_count": 739,
                "image_background": "https://media.rawg.io/media/games/b1d/b1de33eca64ad293702d9554f5ac5cd5.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 4,
        "name": "iOS",
        "slug": "ios",
        "platforms": [
            {
                "id": 3,
                "name": "iOS",
                "slug": "ios",
                "games_count": 77380,
                "image_background": "https://media.rawg.io/media/games/942/9424d6bb763dc38d9378b488603c87fa.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 8,
        "name": "Android",
        "slug": "android",
        "platforms": [
            {
                "id": 21,
                "name": "Android",
                "slug": "android",
                "games_count": 52408,
                "image_background": "https://media.rawg.io/media/games/7a2/7a2500ee8b2c0e1ff268bb4479463dea.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 5,
        "name": "Apple Macintosh",
        "slug": "mac",
        "platforms": [
            {
                "id": 5,
                "name": "macOS",
                "slug": "macos",
                "games_count": 105492,
                "image_background": "https://media.rawg.io/media/games/b45/b45575f34285f2c4479c9a5f719d972e.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 55,
                "name": "Classic Macintosh",
                "slug": "macintosh",
                "games_count": 675,
                "image_background": "https://media.rawg.io/media/games/38a/38af969459ad6e5de116ec8a4a84218c.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 41,
                "name": "Apple II",
                "slug": "apple-ii",
                "games_count": 424,
                "image_background": "https://media.rawg.io/media/screenshots/3d2/3d2bb57b39e2efa39d1c385585b2ea8b.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 6,
        "name": "Linux",
        "slug": "linux",
        "platforms": [
            {
                "id": 6,
                "name": "Linux",
                "slug": "linux",
                "games_count": 78220,
                "image_background": "https://media.rawg.io/media/games/00d/00d374f12a3ab5f96c500a2cfa901e15.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 7,
        "name": "Nintendo",
        "slug": "nintendo",
        "platforms": [
            {
                "id": 7,
                "name": "Nintendo Switch",
                "slug": "nintendo-switch",
                "games_count": 5568,
                "image_background": "https://media.rawg.io/media/games/5eb/5eb49eb2fa0738fdb5bacea557b1bc57.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 8,
                "name": "Nintendo 3DS",
                "slug": "nintendo-3ds",
                "games_count": 1687,
                "image_background": "https://media.rawg.io/media/screenshots/ea9/ea9036e881db5e334e10b2b61aecb29e.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 9,
                "name": "Nintendo DS",
                "slug": "nintendo-ds",
                "games_count": 2483,
                "image_background": "https://media.rawg.io/media/games/9fb/9fbaea2168caea1f806546dfdaaeb1da.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 13,
                "name": "Nintendo DSi",
                "slug": "nintendo-dsi",
                "games_count": 37,
                "image_background": "https://media.rawg.io/media/screenshots/078/078629e997421ca28e9098bd7a87cb10.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 10,
                "name": "Wii U",
                "slug": "wii-u",
                "games_count": 1118,
                "image_background": "https://media.rawg.io/media/games/ba0/ba006ef12175ad4773e5964c320099c4.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 11,
                "name": "Wii",
                "slug": "wii",
                "games_count": 2219,
                "image_background": "https://media.rawg.io/media/games/9f7/9f750cb69a31a42648f45e3681abed3a.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 105,
                "name": "GameCube",
                "slug": "gamecube",
                "games_count": 634,
                "image_background": "https://media.rawg.io/media/games/33d/33d72d63a624f17431d39922359c7bf8.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 83,
                "name": "Nintendo 64",
                "slug": "nintendo-64",
                "games_count": 363,
                "image_background": "https://media.rawg.io/media/screenshots/c1f/c1fd8b15793743563367688b3dd5faa6.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 24,
                "name": "Game Boy Advance",
                "slug": "game-boy-advance",
                "games_count": 953,
                "image_background": "https://media.rawg.io/media/screenshots/52b/52b958a7b263d4f264648b710e76a236.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 43,
                "name": "Game Boy Color",
                "slug": "game-boy-color",
                "games_count": 422,
                "image_background": "https://media.rawg.io/media/screenshots/c21/c2123c3dea40946f705a54772ed6238b.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 26,
                "name": "Game Boy",
                "slug": "game-boy",
                "games_count": 617,
                "image_background": "https://media.rawg.io/media/screenshots/61f/61f183e3d12c7846ed6bd3c027a9fa47.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 79,
                "name": "SNES",
                "slug": "snes",
                "games_count": 973,
                "image_background": "https://media.rawg.io/media/games/98c/98c87b286cd2a2ba942167df384a9bd3.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 49,
                "name": "NES",
                "slug": "nes",
                "games_count": 1010,
                "image_background": "https://media.rawg.io/media/games/f78/f7809ab885f7464845681e5931aabeb8.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 9,
        "name": "Atari",
        "slug": "atari",
        "platforms": [
            {
                "id": 28,
                "name": "Atari 7800",
                "slug": "atari-7800",
                "games_count": 64,
                "image_background": "https://media.rawg.io/media/screenshots/565/56504b28b184dbc630a7de118e39d822.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 31,
                "name": "Atari 5200",
                "slug": "atari-5200",
                "games_count": 64,
                "image_background": "https://media.rawg.io/media/screenshots/678/6786598cba3939d48ed60cbd1a3723f4.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 23,
                "name": "Atari 2600",
                "slug": "atari-2600",
                "games_count": 294,
                "image_background": "https://media.rawg.io/media/screenshots/ff6/ff623993a854663931c1e78d72a16a5a.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 22,
                "name": "Atari Flashback",
                "slug": "atari-flashback",
                "games_count": 30,
                "image_background": "https://media.rawg.io/media/screenshots/2aa/2aa07f58491e14b0183333f8956bc802.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 25,
                "name": "Atari 8-bit",
                "slug": "atari-8-bit",
                "games_count": 308,
                "image_background": "https://media.rawg.io/media/screenshots/038/0385a47d3a43b218204268af5361a19e.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 34,
                "name": "Atari ST",
                "slug": "atari-st",
                "games_count": 836,
                "image_background": "https://media.rawg.io/media/games/694/6941f9167313b2ec0b874c253419aa78.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 46,
                "name": "Atari Lynx",
                "slug": "atari-lynx",
                "games_count": 57,
                "image_background": "https://media.rawg.io/media/screenshots/d71/d71b68d3f6b1810bc9d64d7aea746d30.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 50,
                "name": "Atari XEGS",
                "slug": "atari-xegs",
                "games_count": 22,
                "image_background": "https://media.rawg.io/media/screenshots/769/7691726d70c23c029903df08858df001.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 112,
                "name": "Jaguar",
                "slug": "jaguar",
                "games_count": 39,
                "image_background": "https://media.rawg.io/media/screenshots/241/24188738ed8141b03c767e6bbba28401.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 10,
        "name": "Commodore / Amiga",
        "slug": "commodore-amiga",
        "platforms": [
            {
                "id": 166,
                "name": "Commodore / Amiga",
                "slug": "commodore-amiga",
                "games_count": 2082,
                "image_background": "https://media.rawg.io/media/screenshots/f64/f64fc102b850732764dfd7c29cca3429.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 11,
        "name": "SEGA",
        "slug": "sega",
        "platforms": [
            {
                "id": 167,
                "name": "Genesis",
                "slug": "genesis",
                "games_count": 843,
                "image_background": "https://media.rawg.io/media/games/950/95072fc0c187fbb2c8c5855767d8c90b.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 107,
                "name": "SEGA Saturn",
                "slug": "sega-saturn",
                "games_count": 372,
                "image_background": "https://media.rawg.io/media/screenshots/862/862f0a3da04a5e2d5146b35e75e0d85b.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 119,
                "name": "SEGA CD",
                "slug": "sega-cd",
                "games_count": 163,
                "image_background": "https://media.rawg.io/media/screenshots/9a0/9a01b32ce1a3e0576018a2580e32cf26.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 117,
                "name": "SEGA 32X",
                "slug": "sega-32x",
                "games_count": 46,
                "image_background": "https://media.rawg.io/media/screenshots/d9f/d9f308b5d824ae8f047edc0a998a587b.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 74,
                "name": "SEGA Master System",
                "slug": "sega-master-system",
                "games_count": 232,
                "image_background": "https://media.rawg.io/media/games/0c8/0c8e70a85fd2a341c77ada2a919ca0e1.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 106,
                "name": "Dreamcast",
                "slug": "dreamcast",
                "games_count": 364,
                "image_background": "https://media.rawg.io/media/games/fd7/fd794a9f0ffe816038d981b3acc3eec9.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 77,
                "name": "Game Gear",
                "slug": "game-gear",
                "games_count": 227,
                "image_background": "https://media.rawg.io/media/games/e9a/e9a782a3f40f0e53ab64c7018251053e.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 12,
        "name": "3DO",
        "slug": "3do",
        "platforms": [
            {
                "id": 111,
                "name": "3DO",
                "slug": "3do",
                "games_count": 99,
                "image_background": "https://media.rawg.io/media/screenshots/97c/97cd94d7d6d89a12ed562d3a4e40c4a5.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 13,
        "name": "Neo Geo",
        "slug": "neo-geo",
        "platforms": [
            {
                "id": 12,
                "name": "Neo Geo",
                "slug": "neogeo",
                "games_count": 123,
                "image_background": "https://media.rawg.io/media/screenshots/4cc/4ccee6c3e367f4dd94d19d4857dfc1c9.jpeg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 14,
        "name": "Web",
        "slug": "web",
        "platforms": [
            {
                "id": 171,
                "name": "Web",
                "slug": "web",
                "games_count": 260080,
                "image_background": "https://media.rawg.io/media/screenshots/fa5/fa5614030bcda5f7eb5403c681aec7a6.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    }
]
